export default __webpack_public_path__ + "static/media/carNameRMirror.070e950f.png";